import React from "react";
import { useTranslation } from "react-i18next";
import Delete from "../common/delete";
import Edit from "../common/edit";
import MatTable from "../common/matTable";

const DesignationTable = ({ data, sortColumn, onSort,onEdit, onDelete,heading }) => {
  const { t } = useTranslation(["designation"]);
  const columns = [
    {
      path: "name",
      label: t("Designation")
    },
    { path: "qualificationRequired", label: t("Qualification Required") },
    { path: "experienceRequired", label: t("Experience Required") },
    {
      key: "actiona",
      label:"Action",
      content: (item) => (
        <><Edit title="Edit" icon="edit" onEdit={onEdit} item={item} /> 
        <Delete onDelete={onDelete} item={item} /></>
      ),
    }
  ];

  return (
    <MatTable
      heading={heading}
      data={data}
      columns={columns}
      sortColumn={sortColumn}
      onSort={onSort}
    />
  );
};

export default DesignationTable;
